import { Component, ErrorInfo, ReactNode } from 'react'

import { interWbSession } from '@interco/inter-webview-bridge'

import { AccountInfoError } from './AccountInfoError'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class AccountInfoErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    interWbSession.requestAnalytics('DADOS_BANCARIOS_GA_FLUXO', {
      flow: 'dados-bancarios',
      screen: 'dados-bancarios',
      action_id: 'webview_error',
      error_message: error.toString(),
      component_stack: errorInfo.componentStack ?? '',
    })
  }

  handleRetry = () => {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return <AccountInfoError refetch={this.handleRetry} />
    }

    return this.props.children
  }
}
